module.exports = __webpack_public_path__ + "img/ic_map.eafef60d.svg";